<!--
  Copyright (C) 2020 ExploRêve

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>.

  Full source code is available at <https://gitlab.com/exploreve/frontend>.
-->

<template>
  <div :class="['IM_2_' + this.id]">
    <div class="row justify-content-center m-0">
      <div class="col col-12 col-md-12 p-0">
        <video ref="vid" @ended="show_link" class="main-vid" controls>
          <source src="https://cdn.exploreve.fr/content/IM2/animation_brouillard_debut.webm" type="video/webm" />
          <source src="https://cdn.exploreve.fr/content/IM2/animation_brouillard_debut.mp4" type="video/mp4" />
          <track
            src="https://cdn.exploreve.fr/content/IM2/animation_brouillard_debut.vtt"
            kind="subtitles"
            label="Français"
            srclang="fr"
            default
          />
          Vidéo non supportée.
        </video>
        <div ref="next" class="big-next">
          <router-link class="next" to="/immersion02/1">Vers la suite ></router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "IM_2_0",
  data: function () {
    return {
      id: 0
    };
  },
  methods: {
    emitMusic: function (action, id) {
      this.$emit("audio", { action: action, id: id });
    },
    show_link: function () {
      this.$refs.next.classList.toggle("show");
    }
  }
};
</script>

<style scoped lang="scss">
video.main-vid {
  position: relative;
  margin: 0px auto;
  z-index: 5;
  height: 720px;
}

div.big-next {
  position: relative;
  height: 720px;
  margin: 0px auto;
  top: -720px;
  opacity: 0;
  z-index: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 36px;
  transition: z-index 0.1s linear, opacity 0.5s linear;

  &.show {
    opacity: 1;
    z-index: 10;
  }
}

::cue {
  color: #000;
  background: rgba(255, 255, 255, 0.7);
  /*text-shadow: #999 1px 1px 3px;*/
  font-weight: 600;
  line-height: 1.3em;
}
</style>
